export const Captain = ({ colorBg, colorIcon, className }: any) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<rect width="16" height="16" rx="8" fill={colorBg} />
			<path
				d="M8.26545 11.8845C7.22788 11.8845 6.42303 11.5984 5.85091 11.0263C5.28364 10.4542 5 9.64688 5 8.60446V7.36082C5 6.3281 5.28364 5.53052 5.85091 4.9681C6.42303 4.40082 7.22788 4.11719 8.26545 4.11719C8.85697 4.11719 9.3903 4.22143 9.86545 4.42991C10.3406 4.6384 10.7188 4.93658 11 5.32446L9.93091 6.28446C9.72242 6.04204 9.47515 5.85537 9.18909 5.72446C8.90303 5.59355 8.60242 5.5281 8.28727 5.5281C7.71515 5.5281 7.27152 5.6881 6.95636 6.0081C6.64121 6.3281 6.48364 6.77901 6.48364 7.36082V8.60446C6.48364 9.20082 6.64121 9.66143 6.95636 9.98628C7.27152 10.3111 7.71515 10.4736 8.28727 10.4736C8.60242 10.4736 8.90303 10.4032 9.18909 10.2626C9.47515 10.122 9.72242 9.92325 9.93091 9.66628L11 10.699C10.7188 11.0772 10.3382 11.3705 9.85818 11.579C9.38303 11.7826 8.85212 11.8845 8.26545 11.8845Z"
				fill={colorIcon}
			/>
			<rect
				x="1.25"
				y="1.25"
				width="13.5"
				height="13.5"
				rx="6.75"
				stroke={colorIcon}
				strokeWidth="0.5"
			/>
		</svg>
	);
};
